import { render, staticRenderFns } from "./DayCalendar.vue?vue&type=template&id=1c25d96a&scoped=true"
import script from "./DayCalendar.vue?vue&type=script&lang=ts"
export * from "./DayCalendar.vue?vue&type=script&lang=ts"
import style0 from "./DayCalendar.vue?vue&type=style&index=0&id=1c25d96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c25d96a",
  null
  
)

export default component.exports